import styles from './styles.module.scss';
import { ScoringBar } from './index.jsx';
import ScoringValue from './ScoringValue.jsx';
import { getCropName } from '../../utils/crops';

const ScoringItemBody = ({ t, sensor, season, selectedDate, crops, onShowPopup, onHidePopup }) => {
  return (
    <div className={styles.scoringItemBody}>
      <div className={styles.scoringBarTitle}>
        {season.crop_id && <div className="text-capitalize">{getCropName({t, id: season.crop_id})}</div>}
        {sensor.location.name && <div>{sensor.location.name}</div>}
      </div>
      <ScoringBar
        value={sensor.bbchAI ? sensor.bbchAI.value : null}
        crops={crops}
        cropId={season.crop_id}
      >
        {sensor.bbchAI && (
          <ScoringValue
            value={sensor.bbchAI.value}
            imageUrlNight={sensor.imageUrlNight}
            imageUrlDay={sensor.imageUrlDay}
            description={sensor.bbchAI.description}
            selectedDate={selectedDate}
            locationId={sensor.location.id}
            onValueEnter={onShowPopup}
            onValueLeave={onHidePopup}
          />
        )}
      </ScoringBar>
    </div>
  );
};

export default ScoringItemBody;
